/**
 * Safety margin subtracted from the newest `updated_at` seen. Re-fetching a
 * minute of changes is cheap and merging them again is idempotent.
 */
export const CURSOR_OVERLAP_MS = 60 * 1000;

/**
 * Compute the delta-sync cursor after a server snapshot.
 *
 * The cursor never moves backwards. When no document carries `updated_at`
 * yet (legacy data written before delta sync), the cursor is 0, so the
 * delta query returns exactly the documents changed since the release.
 *
 * @param previous - Current cursor (epoch ms), or null if never synced
 * @param latestUpdatedAt - Newest server `updated_at` in the snapshot, if any
 */
export function nextCursor(
  previous: number | null,
  latestUpdatedAt: Date | null,
): number {
  const candidate = latestUpdatedAt
    ? Math.max(0, latestUpdatedAt.getTime() - CURSOR_OVERLAP_MS)
    : 0;
  return Math.max(previous ?? 0, candidate);
}
